<div class="growerProgramNew">
  <div class="">
    <div class="col-12 margin-l0 TopSec">
      <div class="row">
        <div class="col-12 px-0">
          <h3>
            Seed Discretionary Dashboard
          </h3>
        </div>
        <div class="col-12 px-0">
          <p class="smalltext">
          </p>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-11">
        <app-filter [optionsData]="filterOptionsData" [isShowFilterButton]="false" [isSearchButtonOutside]="true" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
      <div class="col-1 margin-l-rem padding-l0">
        <div class="row">
          <div class="col-12">
            <button mat-raised-button class="btns export-button margin-t12 w100 font-14" (click)="export()">Export</button>
          </div>
        </div>
      </div>
    </div>

    <div class="tableSection">
      <table style="width:100%" class="matTables mat-table mat-elevation-z8" cellspacing="0">
        <thead>
          <tr class="header-row">
            <th style="width:18%" class="mat-header-cell text-left pl-4">Program Name</th>
            <th style="width:12%" class="mat-header-cell text-left pl-2">Budget Amount</th>
            <th style="width:12%" class="mat-header-cell text-center">Committed Dollar Amount</th>
            <th style="width:12%" class="mat-header-cell text-center">Spent Dollar Amount </th>
            <th style="width:12%" class="mat-header-cell text-center">Remaining Budget</th>
            <th style="width:12%" class="mat-header-cell text-center">{{buDisplayName}}</th>
            <th style="width:12%" class="mat-header-cell text-center">Seed Execution Lead</th>
            <th style="width:10%" class="mat-header-cell text-center"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let parent of gridData">
            <tr class="table-row-not-expanded">
              <td style="width:18%" class="mat-cell text-left pl-4">{{parent.masterProgramBudgetTypeName}}</td>
              <td style="width:12%" class="mat-cell text-left pl-2">{{parent.firstLevelTotalDollarAmount | number}}</td>
              <td style="width:12%" class="mat-cell text-center">{{parent.firstLevelCommittedDollarAmount | number}}</td>
              <td style="width:12%" class="mat-cell text-center">{{parent.firstLevelSpentDollarAmount | number}}</td>
              <!--NegativeValue and PositiveValue-->
              <td style="width:12%" *ngIf="parent.firstLevelRemainingDollarAmount>=0" class="mat-cell text-center">{{parent.firstLevelRemainingDollarAmount | number}}</td>
              <td style="width:12%" *ngIf="parent.firstLevelRemainingDollarAmount<0" class="mat-cell text-center negative">({{parent.firstLevelRemainingDollarAmount*-1 | number}})</td>
              <td style="width:12%" class="mat-cell text-center"></td>
              <td style="width:12%" class="mat-cell text-center"></td>
              <td style="width:10%" class="mat-cell text-center">
                Detail <span [ngClass]="parent.isExpanded ? 'downArrowClose':'downArrowOpen'" style="cursor: pointer" (click)="toggle(parent,1);$event.stopPropagation()"></span>

              </td>
              <!--<td class="mat-cell text-center"></td>-->
            </tr>
            <ng-container *ngIf="parent.isExpanded && parent.programMasterLevelVMs">
              <ng-container *ngFor="let child1 of parent.programMasterLevelVMs">
                <tr [@detailExpand]="parent.isExpanded ? 'expanded' : 'collapsed'" class="thirdLevelRow">
                  <td style="width:18%" class="mat-cell text-left pl-4">{{child1.programName}}</td>
                  <td style="width:12%" class="mat-cell text-left pl-2">{{child1.secondLevelTotalDollarAmount | number}}</td>
                  <td style="width:12%" class="mat-cell text-center">{{child1.secondLevelCommittedDollarAmount | number}}</td>
                  <td style="width:12%" class="mat-cell text-center">{{child1.secondLevelSpentDollarAmount | number}}</td>
                  <!--NegativeValue and PositiveValue-->
                  <td style="width:12%" *ngIf="child1.secondLevelRemainingDollarAmount>=0" class="mat-cell text-center">{{child1.secondLevelRemainingDollarAmount | number}}</td>
                  <td style="width:12%" *ngIf="child1.secondLevelRemainingDollarAmount<0" class="mat-cell text-center negative">({{child1.secondLevelRemainingDollarAmount*-1 | number}})</td>
                  <td style="width:12%" class="mat-cell text-center"></td>
                  <td style="width:12%" class="mat-cell text-center"></td>
                  <td style="width:10%" class="mat-cell text-center">
                    Detail <span [ngClass]="child1.isExpanded ? 'dropdownArrowClose':'dropdownArrowOpen'" style="cursor: pointer" (click)="toggle(child1,2);$event.stopPropagation()"> </span>
                  </td>
                </tr>
                <ng-container *ngIf="child1.isExpanded && child1.sdmLevelVMs">
                  <ng-container *ngFor="let child2 of child1.sdmLevelVMs" [@detailExpandNew]="child1.isExpanded ? 'expanded' : 'collapsed'">
                    <tr *ngIf="child2[0].sharedBudgetId > 0" class="lastlevel" style="background: #c4c4c4">

                      <td style="width:18%" class="mat-cell text-left pl-4">{{child1.programName}} ({{child2[0].budgetName}})</td>
                      <td style="width:12%" class="mat-cell text-left pl-2">{{child2[0].thirdLevelTotalDollarAmount | number}}</td>
                      <td style="width:12%" class="mat-cell text-center">{{child2[0].sharedTotalThirdLevelCommittedDollarAmount | number}}</td>
                      <td style="width:12%" class="mat-cell text-center">{{child2[0].sharedTotalThirdLevelSpentDollarAmount | number}}</td>
                      <!--NegativeValue and PositiveValue-->
                      <td style="width:12%" *ngIf="child2[0].thirdLevelRemainingDollarAmount>=0" class="mat-cell text-center">{{child2[0].thirdLevelRemainingDollarAmount | number}}</td>
                      <td style="width:12%" *ngIf="child2[0].thirdLevelRemainingDollarAmount<0" class="mat-cell text-center negative">({{child2[0].thirdLevelRemainingDollarAmount*-1 | number}})</td>
                      <td style="width:12%" class="mat-cell text-center"></td>
                      <td style="width:12%" class="mat-cell text-center"></td>
                      <td style="width:10%" class="mat-cell text-center"></td>
                    </tr>

                    <tr *ngIf="child2[0].sharedBudgetId == null && child1.haveSharedBudget" class="lastlevel" style="background: #e4dcdc">

                      <td style="width:18%" class="mat-cell text-left pl-4">{{child1.programName}} (Other Budget)</td>
                      <td style="width:12%" class="mat-cell text-left pl-2"></td>
                      <td style="width:12%" class="mat-cell text-center"></td>
                      <td style="width:12%" class="mat-cell text-center"></td>
                      <td style="width:12%" class="mat-cell text-center"></td>
                      <td style="width:10%" class="mat-cell text-center"></td>
                    </tr>
                    <ng-container *ngFor="let child3 of child2">
                      <tr class="lastlevel">

                        <td style="width:18%" class="mat-cell text-left pl-4">{{child3.budgetUserName}}</td>
                        <td style="width:12%" class="mat-cell text-left pl-2">{{child3.sharedBudgetId > 0 ? 'Shared' : child3.thirdLevelTotalDollarAmount | number}}</td>
                        <td style="width:12%" class="mat-cell text-center">{{child3.thirdLevelCommittedDollarAmount | number}}</td>
                        <td style="width:12%" class="mat-cell text-center">{{child3.thirdLevelSpentDollarAmount | number}}</td>

                        <!--NegativeValue and PositiveValue-->
                        <td style="width:12%" *ngIf="child3.thirdLevelRemainingDollarAmount>=0" class="mat-cell text-center">{{child3.sharedBudgetId > 0 ? 'Shared' : child3.thirdLevelRemainingDollarAmount | number}}</td>
                        <td style="width:12%" *ngIf="child3.thirdLevelRemainingDollarAmount<0" class="mat-cell text-center negative">({{child3.sharedBudgetId > 0 ? 'Shared' : child3.thirdLevelRemainingDollarAmount*-1 | number}})</td>
                        <td style="width:12%" class="mat-cell text-center">{{child3.buLeadAccountName}}</td>
                        <td style="width:12%" class="mat-cell text-center">{{child3.selAccountName}}</td>
                        <td style="width:10%" class="mat-cell text-center"></td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
